import React, { useState } from "react";
import { Pencil, Check, Eye, EyeOff } from "lucide-react";
import { affiliateAPI } from "../../services/AdminPortal/affiliateAPI";
import { toast } from "react-hot-toast";

const EditAffiliatePartnerModel = ({
  isOpen,
  onClose,
  staffData,
  onUpdate,
}) => {
  const [formData, setFormData] = useState({
    name: staffData?.name || "",
    contact: staffData?.contact || "",
    email: staffData?.email || "",
    // category: staffData?.category || "",
    // commission: staffData?.commission || "",
    status:  "active",
    location: staffData?.location || "",
    branchName: staffData?.branchName || "",
    profileImage:
      staffData?.documents?.find((d) => d.type === "profile_photo")?.filePath ||
      "",
    // commissionDetails: staffData?.commissionDetails || {
    //   rate: "",
    //   fixedAmount: "",
    //   payoutCycle: "",
    //   paymentThreshold: "",
    // },
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith("commissionDetails.")) {
      const key = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        commissionDetails: { ...prev.commissionDetails, [key]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({ ...prev, profileImage: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password && formData.password.length < 6) {
      setErrors({ password: "Password must be at least 6 characters" });
      return;
    }
    try {
      const updates = { ...formData };
      if (!updates.password) delete updates.password;
      await affiliateAPI.updateAffiliatePartner(staffData._id, updates);
      onUpdate(updates);
      toast.success("Affiliate Partner updated successfully!");
      onClose();
    } catch (error) {
      toast.error(error.message);
      console.error("Error updating affiliate partner:", error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-[#131313] text-white p-6 rounded-lg w-full max-w-3xl overflow-y-auto max-h-[90vh]">
        <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
          <Pencil size={18} className="text-yellow-400" />
          Edit Affiliate Partner [{staffData?.name || "Partner"}]
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Profile Picture */}
          <div className="flex items-center gap-6">
            <div className="relative">
              <img
                src={formData.profileImage}
                alt="Profile"
                className="w-20 h-20 rounded-full object-cover border"
              />
              <label className="absolute bottom-0 right-0 bg-yellow-400 text-black p-1 rounded-full border-2 border-[#1e1e1e] cursor-pointer">
                <Pencil size={14} />
                <input
                  type="file"
                  accept="image/*"
                  className="hidden"
                  onChange={handleImageChange}
                />
              </label>
            </div>
          </div>

          {/* Basic Info */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm mb-1">Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full bg-[#131313] border border-[#333] rounded p-2"
              />
            </div>
            <div>
              <label className="block text-sm mb-1">Contact</label>
              <input
                type="tel"
                name="contact"
                value={formData.contact}
                onChange={handleChange}
                className="w-full bg-[#131313] border border-[#333] rounded p-2"
              />
            </div>
            <div>
              <label className="block text-sm mb-1">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full bg-[#131313] border border-[#333] rounded p-2"
              />
            </div>
            {/* <div>
              <label className="block text-sm mb-1">Category</label>
              <input
                type="text"
                name="category"
                value={formData.category}
                onChange={handleChange}
                className="w-full bg-[#131313] border border-[#333] rounded p-2"
              />
            </div> */}
             <div>
              <label className="block text-sm mb-1">Status</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="w-full bg-[#131313] border border-[#333] rounded p-2"
              >
                <option value="active">active</option>
                <option value="inactive">inactive</option>
              </select>
            </div>
          </div>

          {/* Commission & Status */}
          {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm mb-1">Commission</label>
              <input
                type="text"
                name="commission"
                value={formData.commission}
                onChange={handleChange}
                className="w-full bg-[#131313] border border-[#333] rounded p-2"
              />
            </div>
           
          </div> */}

          {/* Branch & Location */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm mb-1">Branch Name</label>
              <input
                type="text"
                name="branchName"
                value={formData.branchName}
                onChange={handleChange}
                className="w-full bg-[#131313] border border-[#333] rounded p-2"
              />
            </div>
            <div>
              <label className="block text-sm mb-1">Location</label>
              <input
                type="text"
                name="location"
                value={formData.location}
                onChange={handleChange}
                className="w-full bg-[#131313] border border-[#333] rounded p-2"
              />
            </div>
          </div>

          {/* Commission Details */}
          {/* <div>
            <label className="block text-sm font-semibold mb-2">Commission Details</label>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <input
                type="number"
                name="commissionDetails.rate"
                placeholder="Rate %"
                value={formData.commissionDetails.rate}
                onChange={handleChange}
                className="w-full bg-[#131313] border border-[#333] rounded p-2"
              />
              <input
                type="number"
                name="commissionDetails.fixedAmount"
                placeholder="Fixed Amount"
                value={formData.commissionDetails.fixedAmount}
                onChange={handleChange}
                className="w-full bg-[#131313] border border-[#333] rounded p-2"
              />
              <input
                type="text"
                name="commissionDetails.payoutCycle"
                placeholder="Payout Cycle"
                value={formData.commissionDetails.payoutCycle}
                onChange={handleChange}
                className="w-full bg-[#131313] border border-[#333] rounded p-2"
              />
              <input
                type="number"
                name="commissionDetails.paymentThreshold"
                placeholder="Payment Threshold"
                value={formData.commissionDetails.paymentThreshold}
                onChange={handleChange}
                className="w-full bg-[#131313] border border-[#333] rounded p-2"
              />
            </div>
          </div> */}

          {/* Password */}
          <div className="relative">
            <label className="block text-sm mb-1">Change Password</label>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter new password"
              className={`w-full bg-[#131313] border rounded p-2 ${
                errors.password ? "border-red-500" : "border-[#333]"
              }`}
            />
            <button
              type="button"
              onClick={() => setShowPassword((prev) => !prev)}
              className="absolute right-2 top-[38px] text-gray-400"
            >
              {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
            {errors.password && (
              <p className="text-red-500 text-xs mt-1">{errors.password}</p>
            )}
          </div>

          {/* Buttons */}
          <div className="flex justify-between mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-white text-white rounded hover:bg-red-500 transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-[#FFCA20] text-black rounded flex items-center gap-2 hover:bg-yellow-300 transition"
            >
              Save Changes <Check size={16} />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditAffiliatePartnerModel;
